export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='52' height='100'%3e%3cpath d='m5 50 21-35 21 35-21 35z'/%3e%3c/svg%3e"